import type { RecordingsSort } from "@sunrise/backend-types";
import { atom } from "jotai";

/**
 * This is the sorting for ALL recordings.
 */
export const recordingsSortAtom = atom<RecordingsSort>("dateDesc");
